import { InputProps } from 'interfaces'
import * as React from 'react'
import { Input } from './input'

type InputPhoneFullProps = InputProps &
	React.InputHTMLAttributes<HTMLInputElement>

const NON_DIGIT_REGEX = /\D/g
const US_COUNTRY_CODE = '1'
const US_MAX_DIGITS = 11
const US_AREA_CODE_LENGTH = 3
const US_EXCHANGE_LENGTH = 6
const US_LOCAL_LENGTH = 10

const formatFullPhone = (rawDigits: string): string => {
	if (!rawDigits) return ''
	const digits = rawDigits.slice(0, 15) // E.164 max 15 digits
	if (digits.startsWith(US_COUNTRY_CODE) && digits.length <= US_MAX_DIGITS) {
		const local = digits.slice(1)
		if (!local) return `+${US_COUNTRY_CODE}`
		if (local.length < US_AREA_CODE_LENGTH)
			return `+${US_COUNTRY_CODE} ${local}`
		if (local.length < US_EXCHANGE_LENGTH)
			return `+${US_COUNTRY_CODE} (${local.slice(
				0,
				US_AREA_CODE_LENGTH
			)}) ${local.slice(US_AREA_CODE_LENGTH)}`
		if (local.length < US_LOCAL_LENGTH)
			return `+${US_COUNTRY_CODE} (${local.slice(
				0,
				US_AREA_CODE_LENGTH
			)}) ${local.slice(US_AREA_CODE_LENGTH, US_EXCHANGE_LENGTH)}-${local.slice(
				US_EXCHANGE_LENGTH
			)}`
		return `+${US_COUNTRY_CODE} (${local.slice(
			0,
			US_AREA_CODE_LENGTH
		)}) ${local.slice(US_AREA_CODE_LENGTH, US_EXCHANGE_LENGTH)}-${local.slice(
			US_EXCHANGE_LENGTH,
			US_LOCAL_LENGTH
		)}`
	}
	return `+${digits}`
}

export const InputPhoneFull: React.FC<InputPhoneFullProps> = ({
	name,
	setValueInput,
	rules,
	watchValue,
	...props
}) => {
	const handlePaste = React.useCallback(
		(e: React.ClipboardEvent<HTMLInputElement>): void => {
			e.preventDefault()
			const pasted = e.clipboardData.getData('text')
			const digits = pasted.replace(NON_DIGIT_REGEX, '')
			if (setValueInput) {
				setValueInput(name, formatFullPhone(digits), { shouldValidate: true })
			}
		},
		[name, setValueInput]
	)

	const handleChange = React.useCallback(
		(e: React.ChangeEvent<HTMLInputElement>): void => {
			const digits = e.target.value.replace(NON_DIGIT_REGEX, '')
			setValueInput?.(name, formatFullPhone(digits), { shouldValidate: true })
		},
		[name, setValueInput]
	)

	return (
		<Input
			{...props}
			name={name}
			type="tel"
			rules={rules}
			watchValue={watchValue}
			maxLength={18}
			onChangeCustom={handleChange}
			onPaste={handlePaste}
		/>
	)
}
